// extracted by mini-css-extract-plugin
export default {"icon":"AvatarIcon_icon__lgcsF"};